import ClientDashboardLoginOverlay from './index.jsx'
import { useClientDashboardLogin } from '../../providers/ClientDashboardLoginProvider/ClientDashboardLoginProvider'
import { useContext } from 'react'
import { LayoutContext } from 'providers/LayoutProvider'
import { FdrPage } from 'utils/environmentConfig'

const ClientDashboardLoginOverlayGate = ({ footerContainerProps, applyFdrUrl, upscopeUrl }) => {
  const { state } = useContext(LayoutContext)
  const { isOpen, closeLoginOverlay, openedFromShowFormCookie } = useClientDashboardLogin()

  if (state?.siteEnv !== FdrPage || !isOpen) {
    return null
  }

  return (
    <ClientDashboardLoginOverlay
      onClose={closeLoginOverlay}
      footerContainerProps={footerContainerProps}
      openedFromShowFormCookie={openedFromShowFormCookie}
      applyFdrUrl={applyFdrUrl}
      upscopeUrl={upscopeUrl}
    />
  )
}

export default ClientDashboardLoginOverlayGate
